import { atom } from 'recoil';

export const flowDataState = atom({
    key: "flowState",
    default: {
        flow: null
    } as {
        flow: null | string
    }
})